// @flow
import { SIGN_OUT } from '../../../actions/authActions';
import {
  FETCH_MULE_RED_DOT_STATE_REQUEST,
  FETCH_MULE_RED_DOT_STATE_SUCCESS,
  FETCH_MULE_RED_DOT_STATE_FAILURE,
  REFRESH_MULE_RED_DOT_STATE_REQUEST,
  REFRESH_MULE_RED_DOT_STATE_SUCCESS,
  REFRESH_MULE_RED_DOT_STATE_FAILURE,
} from '../actions/muleCustStateActions';
import { MuleRedDotState } from '../types/muleCustStateType';

const muleRedDotInitState: MuleRedDotState = {
  redDot: undefined,
  redDotIsLoaded: false,
  redDotIsRefreshed: false,
};

export default function featuresReducer(
  state: MuleRedDotState = muleRedDotInitState,
  action: { type: string; payload?: any },
): MuleRedDotState {
  let nextState = { ...state };

  switch (action.type) {
    case SIGN_OUT:
      // console.log(TAG, 'Init policy started');
      nextState = { ...muleRedDotInitState };
      // console.log(TAG, 'nextState', nextState);
      return nextState;
    // ----- READ STATE -----
    case FETCH_MULE_RED_DOT_STATE_REQUEST:
      nextState.redDot = undefined;
      nextState.redDotIsLoaded = muleRedDotInitState.redDotIsLoaded;
      return nextState;
    case FETCH_MULE_RED_DOT_STATE_SUCCESS:
      nextState.redDot = action.payload || undefined;
      nextState.redDotIsLoaded = true;
      return nextState;
    case FETCH_MULE_RED_DOT_STATE_FAILURE:
      nextState.redDot = undefined;
      nextState.error = action.payload || '';
      nextState.redDotIsLoaded = true;
      return nextState;
    case REFRESH_MULE_RED_DOT_STATE_REQUEST:
      nextState.redDot = undefined;
      nextState.redDotIsRefreshed = muleRedDotInitState.redDotIsRefreshed;
      return nextState;
    case REFRESH_MULE_RED_DOT_STATE_SUCCESS:
      nextState.redDot = action.payload || undefined;
      nextState.redDotIsRefreshed = true;
      return nextState;
    case REFRESH_MULE_RED_DOT_STATE_FAILURE:
      nextState.redDot = undefined;
      nextState.error = action.payload || '';
      nextState.redDotIsRefreshed = true;
      return nextState;
    default:
      return nextState;
  }
}
